import React, { useRef } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Layout from "../../components/layout";
import SearchEngineOptimization from "../../components/SearchEngineOptimization";
import PartnerForm from "../../components/Forms/PartnerForm";
import Polygon from "./polygon.svg";
import "./styles.scss";
import normalizeAssetUrl from "../../utils/normalizeAssetUrl";

function PartnerPage() {
	const formSection = useRef(null);

	const data = useStaticQuery(graphql`
		query {
			contentfulPartnerPage {
				title
				description: Body
				partnerSection {
					name
					partners {
						id
						name
						slug
						logo {
							file {
								contentType
								url
								fileName
								details {
									image {
										width
										height
									}
								}
							}
						}
						url
					}
				}
			}
		}
	`);

	const {
		contentfulPartnerPage: { title, description, partnerSection },
	} = data;

	const handleScrollToForm = () => {
		formSection.current.focus();
	};

	return (
		<Layout>
			<SearchEngineOptimization title={title} description={description} />
			<div className="partners">
				<section className="section section--is-spacious">
					<div className="container container--is-narrow">
						<h1 className="partners__heading">
							{title}
							<div className="partners__polygon">
								<img src={Polygon} alt="" aria-hidden="true" />
							</div>
						</h1>
						<p>{description}</p>
						<div className="partners__cta">
							<button
								className="btn btn--black-green btn--large"
								onClick={handleScrollToForm}
							>
								Become a partner
							</button>
						</div>
					</div>
				</section>
				<section className="section section--is-gray">
					<div className="container">
						{partnerSection.map((partnerType, index) => {
							const { partners } = partnerType;
							return (
								<div className="partners__type" key={index}>
									<h2 className="partners__type-heading">{partnerType.name}</h2>

									<ul className="partners__partner-list">
										{partners.map((partner) => {
											const { id, name, logo, slug } = partner;

											const logoContent =
												logo?.file?.fileName?.includes(".svg") && logo?.file?.url ? (
													<div
														style={{
															backgroundImage: `url(${normalizeAssetUrl(logo.file.url)})`,
															width: "200px",
															height: "50px",
															backgroundRepeat: "no-repeat",
															backgroundPosition: "center",
															backgroundSize: "contain",
														}}
													>
														<span className="visually-hidden">{logo?.file?.fileName}</span>
													</div>
												) : (
													logo?.file?.url && <img src={normalizeAssetUrl(logo.file.url)} alt={name} />
												);

											return (
												<li key={id}>
													<Link to={`/partners/${slug}`} className="partners__partner">
														{logoContent}
													</Link>
												</li>
											);
										})}
									</ul>
								</div>
							);
						})}
					</div>
				</section>
				<section className="section">
					<div className="container container--is-narrow">
						<div ref={formSection} tabIndex="0">
							<PartnerForm />
						</div>
					</div>
				</section>
			</div>
		</Layout>
	);
}

export default PartnerPage;
